<template>
  <v-footer class="sv-footer py-0" tile height="24" color="transparent">
    <v-spacer />
    <span class="sv-footer-text font-weight-light copyright">
      {{ version }}
    </span>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    version() {
      const appVersion = this.$store.getters.getVersion;
      return appVersion != "null" ? `v ${appVersion}` : "";
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/branding.scss";

.sv-footer.theme--light {
  border-top: 1px solid $brand-menu-border !important;
}
.sv-footer-text {
  a {
    text-decoration: none;
  }
  font-size: 10px;
  color: $brand-menu-inactive-text;
}
</style>
